/**
 * Service for handling course-dates
 */

import moment from 'moment'

import Backend from '../Backend'
import LastEditorEntry from './LastEditorEntry'

/* @ngInject */
class CourseDateData {

  static saveNewDate = function (courseId, date) {
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    let payload = Object.assign({}, date)

    payload = CourseDateData.convertDates(
        CourseDateData.stripDateObject(payload)
    )
    payload.KD_Bearbeiter = lastEditMessage

    payload.KD_Kursstamm_ID = courseId

    return Backend.postData(`/api/TAB_KURSTERMINDATEN/`, payload)
  }

  static updateDate = function (date) {
    const id = date.KD_ID
    const lastEditMessage = LastEditorEntry.getLastEditorMessage()

    let payload = Object.assign({}, date)

    payload = CourseDateData.convertDates(
        CourseDateData.stripDateObject(payload)
    )
    delete payload['KD_ID']
    payload.KD_Bearbeiter = lastEditMessage

    return Backend.putData(`/api/TAB_KURSTERMINDATEN/${id}`, payload)
  }

  static deleteDate = function (dateID) {
    return Backend.deleteData(`/api/TAB_KURSTERMINDATEN/${dateID}`)
  }

  static stripDateObject = function (obj) {
    const keys = Object.keys(obj)
    for (const key of keys) {
      if (!key.startsWith('KD_')) {
        delete obj[key]
      }
    }
    return obj
  }

  static convertDates = function (obj) {
    // Tages-Felder (DATE) tragen keine Uhrzeit und werden als lokaler Tag
    // gespeichert, damit sich der angezeigte Tag nicht verschiebt.
    const dayFields = ['KD_Anfangstag', 'KD_Letzter_Tag']
    // Uhrzeit-Felder (DATETIME) werden als UTC gespeichert, passend zur
    // Treiber-Konfiguration (timezone: 'Z') und der clientseitigen
    // Lokalkonvertierung beim Lesen.
    const timeFields = ['KD_Beginn', 'KD_Ende']
    for (const key of dayFields) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null) {
          delete obj[key]
        } else {
          obj[key] = moment(obj[key]).format("YYYY-MM-DD HH:mm:ss")
        }
      }
    }
    for (const key of timeFields) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === null) {
          delete obj[key]
        } else {
          obj[key] = moment(obj[key]).utc().format("YYYY-MM-DD HH:mm:ss")
        }
      }
    }
    return obj
  }
}

export default CourseDateData;
